export enum SopDetailEvents {
    SOP_DETAIL_CHANGED = 'SOP_DETAIL_CHANGED',
    SOP_BLOCKS_LOADED = 'SOP_BLOCKS_LOADED',
}
